/* tslint:disable:max-line-length */
import * as React from 'react';
import pure from 'recompose/pure';

class SearchIcon extends React.Component<{ style: any }> {
  render() {
    return <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      fill="currentcolor" {...this.props}>
      <g id="698627-icon-111-search-512">
        <path
          d="M9.5,18 C4.80557963,18 1,14.1944204 1,9.5 C1,4.80557963 4.80557963,1 9.5,1 C14.1944204,1 18,4.80557963 18,9.5 C18,14.1944204 14.1944204,18 9.5,18 Z M9.5,16 C13.0898509,16 16,13.0898509 16,9.5 C16,5.91014913 13.0898509,3 9.5,3 C5.91014913,3 3,5.91014913 3,9.5 C3,13.0898509 5.91014913,16 9.5,16 Z"
          id="Oval-7"
        />
        <path
          d="M17.1893398,13.0931458 L20.017767,13.0931458 L20.017767,22.6997475 C20.017767,23.4807961 19.384602,24.113961 18.6035534,24.113961 L18.6035534,24.113961 C17.8225048,24.113961 17.1893398,23.4807961 17.1893398,22.6997475 L17.1893398,13.0931458 Z"
          id="Rectangle-14"
          transform="translate(18.603553, 18.603553) rotate(-45.000000) translate(-18.603553, -18.603553) "
        />
      </g>
    </svg>;
  }
}

const Icon = pure(SearchIcon);
Icon.displayName = 'SearchIcon';
export default Icon;
